
<template>
    <div v-if="display" class="filter-cont" :style="styles">
        <div class="filter-area">
            <div class="filter-label">{{label}}</div>
        </div>
        <div class="filter-buttons" style="bottom: 0;">
            <button
                @click="setOrder('ASC')"
                :class="{'filter-up': true, 'filter-order-active': name === sortVar && sortType === 'ASC'}">
            </button>
            <button
                @click="setOrder('DESC')"
                :class="{'filter-down': true, 'filter-order-active': name === sortVar && sortType === 'DESC'}">
            </button>
        </div>
    </div>
    <div v-else>{{label}}</div>
</template>

<script>
export default {
  name: 'orderField',
  props: {
    name: { type: String, required: true },
    label: { type: String, required: true },
    styles: { type: String, default: ''},
    display: Boolean
  },
  computed: {
    sortVar () { return (this.$route.query || {}).sortVar || '' },
    sortType () { return (this.$route.query || {}).sortType || '' }
  },
  methods: {
    setOrder (type) {
      const query = _.clone(this.$route.query) || {}
      if (query.sortVar === this.name && query.sortType === type) {
        delete query.sortVar
        delete query.sortType
      } else {
        query.sortVar = this.name
        query.sortType = type
      }

      this.$router.replace({ query })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/filter/orderField.vue